import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	categoryContainer: {
		display       : "flex",
		flexDirection : "column"
	},
	categoryName: {
		fontWeight  : "500",
		fontSize    : "2rem",
		cursor      : "pointer",
		marginRight : "1.5rem"
	},
	headingWrapper: {
		display      : "flex",
		alignItems   : "center",
		marginBottom : "1.5rem",
		width        : "fit-content"
	},
	hoverText: {
		color      : theme.other.paletteNew.primaryDarkBlue,
		fontWeight : "500",
		fontSize   : "2rem",
		cursor     : "pointer",
		alignItems : "center",
		display    : "flex"
	},
	arrowIcon: {
		height : "20px",
		width  : "20px"
	},
	animateText: {
		display    : "flex",
		alignItems : "center"
	}
} ) );
